import { createReducer, on } from '@ngrx/store';
import * as ScheduleActions from './schedule.actions';
import { Schedule } from 'app/modules/masters/schedule-master/models/schedule.model';
import { initialScheduleState } from './schedule.state';

export const scheduleFeatureKey = 'schedule'; // ✅ Fix #1


export const scheduleReducer = createReducer(
  initialScheduleState,

  // Load
  on(ScheduleActions.loadSchedules, (state, { sortBy, sortOrder, search, scheduleStatus }) => ({
    ...state,
    loading: true,
    error: null,
    sortBy: sortBy ?? state.sortBy,
    sortOrder: sortOrder ?? state.sortOrder,
    listSearch: search !== undefined ? search : state.listSearch,
    scheduleStatus: scheduleStatus !== undefined ? scheduleStatus : state.scheduleStatus,
  })),
  on(ScheduleActions.loadSchedulesSuccess, (state, { schedules, sortBy, sortOrder }) => ({
    ...state,
    schedules,
    loading: false,
    error: null,
    sortBy,
    sortOrder,
  })),
  on(ScheduleActions.loadSchedulesFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Create
  on(ScheduleActions.createSchedule, (state) => ({ ...state, loading: true, error: null })),
  on(ScheduleActions.createScheduleSuccess, (state, { schedule }) => ({
    ...state,
    schedules: [...state.schedules, schedule],
    loading: false,
    error: null,
  })),
  on(ScheduleActions.createScheduleFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Update
  on(ScheduleActions.updateSchedule, (state) => ({ ...state, loading: true, error: null })),
  on(ScheduleActions.updateScheduleSuccess, (state, { schedule }) => ({
    ...state,
    schedules: state.schedules.map((s) => (s.id === schedule.id ? schedule : s)),
    loading: false,
    error: null,
  })),
  on(ScheduleActions.updateScheduleFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Delete
  on(ScheduleActions.deleteSchedule, (state) => ({ ...state, loading: true, error: null })),
  on(ScheduleActions.deleteScheduleSuccess, (state) => ({
    ...state,
    loading: false,
    error: null,
  })),
  on(ScheduleActions.deleteScheduleFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Duplicate check
  on(ScheduleActions.checkScheduleNameDuplicateSuccess, (state, { exists }) => ({
    ...state,
    nameExists: exists,
  })),

  on(ScheduleActions.checkScheduleNameDuplicateFailure, (state, { error }) => ({
    ...state,
    error,
  })),

// Search
on(ScheduleActions.searchSchedules, (state) => ({
  ...state,
  loading: true,
  error: null,
})),

on(ScheduleActions.searchSchedulesSuccess, (state, { schedules, sortBy, sortOrder }) => ({
  ...state,
  schedules,
  loading: false,
  error: null,
  sortBy,
  sortOrder,
})),

on(ScheduleActions.searchSchedulesFailure, (state, { error }) => ({
  ...state,
  loading: false,
  error,
})),

);


